<div class="bp-modal">
  <bp-modal-header>
    <a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section pt-10">
      <bp-icon class="info-icon" icon="info" size="32" theme="regular"></bp-icon>
      <h2 class="bp-modal-title">{{ "cash_plus_rolls_on_working_days" | translate }}</h2>
      <div class="bp-modal-content">{{ "cash_plus_tooltip_working_days_content" | translate }}</div>
    </div>
    <div class="roll-details">
      @for (fiat of fiatList$ | async; track fiat) {
        <div class="roll-hours">
          <div class="fiat-symbol">{{ fiat.symbol }}</div>
          <div>{{ fiat.time }}</div>
        </div>
      }
    </div>
  </div>
</div>
